const DepartmentFilter = ({ departments, handleDepartmentChange, selectedDepartment }) => {
  const findAndReplaceNames = (dataArray, replacements) => {
    const newDataArray = dataArray.map(item => {
      const newName = replacements[item.name] || item.name;
      return { ...item, replacedName: newName };
    });
    return newDataArray;
  };

  // Usage:
  const replacements = {
    'CFO Team': 'Finance and Accounting',
    EPD: 'Engineering, Product, and Design',
    GTM: 'Go-To-Market'
  };

  const updatedDepartments = findAndReplaceNames(departments, replacements);
  return (
    <div className="relative">
      <select
        className="w-full p-2 pr-24 border rounded-lg outline-none border-neutral-200 md:min-w-48 md:w-fit"
        name="department-select"
        id="department-select"
        onChange={handleDepartmentChange}
        value={selectedDepartment}
      >
        <option value="">All Departments</option>
        {updatedDepartments.map(department => (
          <option key={department.id} value={department.name}>
            {department.replacedName}
          </option>
        ))}
      </select>
    </div>
  );
};
export default DepartmentFilter;
